// Values mirror the backend validation (config/tenantverify.php and StorePropertyRequest).
export const SA_PROVINCES = [
  'Eastern Cape', 'Free State', 'Gauteng', 'KwaZulu-Natal', 'Limpopo',
  'Mpumalanga', 'Northern Cape', 'North West', 'Western Cape'
];

export const PROPERTY_TYPES = [
  { value: 'apartment', label: 'Apartment' },
  { value: 'house', label: 'House' },
  { value: 'townhouse', label: 'Townhouse' },
  { value: 'room', label: 'Room' },
  { value: 'other', label: 'Other' }
];

export const ORGANISATION_TYPES = [
  { value: 'landlord', label: 'I own the property (private landlord)' },
  { value: 'agent', label: 'I am a letting agent' },
  { value: 'property_manager', label: 'I manage properties for others' }
];

export const MANDATE_LABELS = {
  none: 'Not provided',
  pending: 'Received, waiting for review',
  verified: 'Verified',
  expired: 'Expired',
  revoked: 'Not accepted'
};
